import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "8.498",
      cy: "8.877",
      r: "7.6",
      stroke: "currentColor",
      "stroke-width": ".75"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-width": ".1",
      d: "M7.474 7.43c.003-.966-.848-1.74-2.13-1.74-1.244 0-2.228.718-2.253 1.778l-.002.051h1.202l.001-.048c.017-.474.476-.784 1.046-.784.285 0 .518.084.678.225.16.14.252.34.25.584a.75.75 0 0 1-.288.605c-.185.147-.451.234-.77.234H4.6v.953h.608c.393 0 .7.095.907.252a.77.77 0 0 1 .315.637.76.76 0 0 1-.305.618c-.195.152-.473.242-.802.242-.625 0-1.08-.311-1.105-.77l-.002-.047h-1.26l.002.051c.032 1.07 1.02 1.793 2.368 1.793 1.365 0 2.386-.759 2.383-1.83.001-.393-.125-.734-.369-.992-.22-.234-.532-.396-.924-.471.636-.179 1.061-.67 1.058-1.34Zm0 0h-.05.05ZM8.78 5.773h-.05v6.208h2.192c.973 0 1.753-.291 2.291-.829s.827-1.317.827-2.281c0-.962-.29-1.737-.821-2.273-.532-.536-1.303-.825-2.254-.825zm1.195 5.15V6.83h.925q.95.001 1.422.505c.316.335.482.844.482 1.536 0 .695-.166 1.206-.486 1.544-.32.337-.801.509-1.452.509z"
    }, null, -1)
  ])))
}
export default { render: render }